// extracted by mini-css-extract-plugin
export default {"cls1":"Cv0A7ePgkeDkO7MuPjqu","cls2":"QAwpJHOtaFXockjO9zha Cv0A7ePgkeDkO7MuPjqu","isTabletDown":"fZRNHmM6Rt7SxV_AHGy6","isPhone":"AhglWCz6CNQNLakLNis7"};